/* ControlUserSessionAddon.js */

"use strict";
const ControlUserSession = require("../ControlUserSession");

class ControlUserSessionAddon extends ControlUserSession {
    constructor(logger, router, di, userFeedback, UserEntity) {
        super(logger, router, di, userFeedback, UserEntity);
    }
    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /* START OVERIDDEN METHODS */
    /*******************************************/

    /*******************************************/
    /* END OVERRIDEN METHODS */
    /* START STEVE ADD-ON METHODS              */
    /*******************************************/
    initialize() {
        //jshint ignore:line
    }
    startUp() {
        //jshint ignore:line
    }
    /*******************************************/
    /* END STEVE ADD-ON METHODS                */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER API METHODS */
    /*******************************************/
}
module.exports = ControlUserSessionAddon;
module.exports.$inject = [
    "$teve.logger",
    "$teve.router",
    "$teve.di",
    "$teve.ui.userFeedback",
    "$teve.user",
];
